module.exports = __webpack_public_path__ + "media/images/application/template/arrow-right-c1971fe36689ca282d39e3b15899d66f.svg";